import appConstants from "../../../../../appConstants";
import { ToggleRenderer } from "../../../../dataGrid/cellRenderer";
import { DropdownEditor } from "../../../../dataGrid/cellEditors";
import { suppressEnter } from "../../../../dataGrid/gridUtilities";
export default class GridConfig {
    constructor(configuration){
        const config = configuration || {};
        this.name = "GridConfiguration";
        this.config = GridConfig.getConfiguration(config);
    }
    static getConfiguration(config) {
      return GridConfig.getDefaultConfiguration();
    }

    static getDefaultConfiguration() {
    return {
      title: appConstants.gridNames.AnchorPointGrid,
      keyColumn: "anchorPointName",
      rowSelection: "multiple",
      rowDeselection: true,
      defaultColDef:{
        sortable: true,
        resizable: true
      },
      columns: [
        {
          headerName: "Status",
          field: "isSelected",
          filter: false,
          minWidth: appConstants.columnWidth.AP_STATUS,
          maxWidth: appConstants.columnWidth.AP_STATUS,
          cellRendererFramework: ToggleRenderer,
          cellStyle: {padding: '0px 10px'}

        },
        {
          headerName: "Name",
          field: "anchorPointName",
          tooltipField: "anchorPointName",
          minWidth: appConstants.columnWidth.AP_NAME
        },
        {
          headerName: "Empty time",
          field: "emptyTime",
          minWidth: appConstants.columnWidth.AP_EMPTYTIME,
        },
        {
          headerName: "Route",
          field: "routeAssigned",
          minWidth: appConstants.columnWidth.AP_ROUTE,
          editable: params => params.data.isSelected,
          cellEditorFramework: DropdownEditor,
          cellEditorParams: {
            isMultiSelection: true,
            noNullValue: true
          },
          //tooltipField: "routeAssigned",
          valueFormatter: params => params.value && Array.isArray(params.value) ? params.value.map(v => v.label).join(", ") : null,
          suppressKeyboardEvent: suppressEnter
        }
      ]
    }
  }
}
